import styled from 'astroturf/react'
import { useLocation } from 'react-router-dom'
import { ArrowRightIcon, AtmCardIcon, TimeClockCircleIcon } from '@calendly/ui/components/icons'
import { BareButton } from '@calendly/ui/components/bare-button'
import { HtmlParser } from '@calendly/html-parser'
import { buildQuery, parseQuery } from '@calendly/http-tools'
const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
const colorStrokeMedium = 'var(--colorStrokeMedium, var(--coreColorNeutral500))'
const colorTextAction = 'var(--colorTextAction, var(--coreColorBlue700))'
const colorTextSecondary = 'var(--colorTextSecondary, var(--coreColorNeutral600))'
import { BodyText, HeadingText } from '@calendly/ui/components/typography'

import { useI18n } from 'locales'
import _Card from "event_type_card-Card.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/landing_page/event_type_card.js?styleId=Card";
import _Header from "event_type_card-Header.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/landing_page/event_type_card.js?styleId=Header";
import _Description from "event_type_card-Description.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/landing_page/event_type_card.js?styleId=Description";
import _Footer from "event_type_card-Footer.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/landing_page/event_type_card.js?styleId=Footer";
import _FooterGroup from "event_type_card-FooterGroup.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/landing_page/event_type_card.js?styleId=FooterGroup";
import _FooterContainer from "event_type_card-FooterContainer.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/landing_page/event_type_card.js?styleId=FooterContainer";
import _BookingLink from "event_type_card-BookingLink.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/landing_page/event_type_card.js?styleId=BookingLink";


const Card = /*#__PURE__*/styled('div', null, {
  displayName: "Card",
  styles: _Card
})
const Header = /*#__PURE__*/styled('header', null, {
  displayName: "Header",
  styles: _Header
})
const Description = /*#__PURE__*/styled('section', null, {
  displayName: "Description",
  styles: _Description
})
const Footer = /*#__PURE__*/styled('footer', null, {
  displayName: "Footer",
  styles: _Footer
})
const FooterGroup = /*#__PURE__*/styled('span', null, {
  displayName: "FooterGroup",
  styles: _FooterGroup
})
const FooterContainer = /*#__PURE__*/styled('span', null, {
  displayName: "FooterContainer",
  styles: _FooterContainer
})
const BookingLink = /*#__PURE__*/styled(BareButton, null, {
  displayName: "BookingLink",
  styles: _BookingLink,
  attrs: props => ({
    ...props,
    as: 'a'
  })
})

const formatPaymentAmount = ([amountInCents, currency]) => {
  const paymentAmount = Intl.NumberFormat(undefined, {
    style: 'currency',
    currency
  }).format(amountInCents / 100)

  return paymentAmount.slice(-3) === '.00' ? paymentAmount.slice(0, -3) : paymentAmount
}

export const EventTypeCard = ({ eventType }) => {
  const { i18n } = useI18n()
  // pass along all parameters to capture UTM
  const { search: searchString } = useLocation()
  const query = buildQuery({ back: 1, ...parseQuery(searchString) })

  return (
    <Card>
      <Header>
        <HeadingText size="small" level={1}>
          {eventType.name}
        </HeadingText>
      </Header>
      <Description>
        {!!eventType.description && HtmlParser(eventType.description)}
      </Description>
      <Footer>
        <FooterGroup>
          <FooterContainer>
            <TimeClockCircleIcon />
            <BodyText inline>
              {eventType.duration}
            </BodyText>
          </FooterContainer>
          {!!eventType.payment && (
          <FooterContainer>
            <AtmCardIcon />
            <BodyText inline>
              {formatPaymentAmount(eventType.payment)}
            </BodyText>
          </FooterContainer>
          )}
        </FooterGroup>
        <BookingLink href={`${eventType.url}?${query}`}>
          {i18n.t('booking.event_types_landing_page.event_type_link')}
          <ArrowRightIcon />
        </BookingLink>
      </Footer>
    </Card>
  )
}
